import BasicButton from "../../../../components/Buttons/BasicButton";
import XsCont from "../../../../components/containers/Xs";
import HeaderWithoutSignIn from "../../../../components/headers/HeaderWithoutSignIn";
import { Box, Container, Typography } from "@mui/material";
import React from "react";
import { useNavigate } from "react-router-dom";

const PhoneNumChangeCompletePage: React.FC = () => {
  const navigate = useNavigate();
  const handleClickButton = () => {
    navigate("/update");
  };
  return (
    <>
      <HeaderWithoutSignIn />
      <Container maxWidth={"xl"}>
        <Box textAlign="center" mt={15}>
          <Typography variant="h5" gutterBottom>
            メールアドレス変更完了
          </Typography>
        </Box>
        <Box mt={10} textAlign="center">
          <Typography variant="body1" gutterBottom>
            メールアドレを変更しました。
          </Typography>
        </Box>
      </Container>
      <XsCont>
        <BasicButton onClick={handleClickButton} mt={10}>
          情報変更ページ
        </BasicButton>
      </XsCont>
    </>
  );
};

export default PhoneNumChangeCompletePage;
